import t from "@/lang/lang";
import { AddressFieldsDebounced } from "@/services/backend/addresses/components/address-fields-debounced";
import { Address } from "@/services/backend/addresses/types/address";
import { Representative } from "@/services/backend/representatives/types/representative";
import { TextInputField } from "@/shared/components/field/input-field";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";

export function GfsPostalAddressCard({
  address,
  onAddressChange,
  contactRole,
  onContactRoleChange,
  disabled,
  title = t("Postadresse"),
  description = t("Adresse des Kunden"),
}: {
  address: Address;
  onAddressChange: (address: Address) => void;
  contactRole: string;
  onContactRoleChange: (contactRole: string) => void;
  disabled?: boolean;
  title?: string;
  description?: string;
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <AddressFieldsDebounced
          address={address}
          onAddressChange={onAddressChange}
          disabled={disabled}
        />
        <TextInputField
          label={t("Funktion des Ansprechpartners")}
          description={t(
            "Wird unter dem Ansprechpartner in der Postanschrift angezeigt.",
          )}
          text={contactRole}
          onTextChange={onContactRoleChange}
          disabled={disabled}
        />
      </CardContent>
    </Card>
  );
}

export function GfsRepresentativeCard({
  representative,
  onRepresentativeChange,
  disabled,
}: {
  representative: Representative;
  onRepresentativeChange: (representative: Representative) => void;
  disabled?: boolean;
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Betreuer")}</CardTitle>
        <CardDescription>
          {t("Kontakt für Rückfragen des Kunden.")}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <TextInputField
          label={t("Name")}
          text={representative.name}
          disabled={disabled}
          onTextChange={(name) =>
            onRepresentativeChange({ ...representative, name })
          }
        />
        <TextInputField
          label={t("Mobil")}
          text={representative.mobilephone}
          disabled={disabled}
          onTextChange={(mobilephone) =>
            onRepresentativeChange({ ...representative, mobilephone })
          }
        />
        <TextInputField
          label={t("Telefon")}
          text={representative.phone}
          disabled={disabled}
          onTextChange={(phone) =>
            onRepresentativeChange({ ...representative, phone })
          }
        />
        <TextInputField
          label={t("E-Mail")}
          text={representative.email}
          disabled={disabled}
          onTextChange={(email) =>
            onRepresentativeChange({ ...representative, email })
          }
        />
      </CardContent>
    </Card>
  );
}
